import React from "react";
import "./OrderDetails.css";
import MainLayout from "components/layout/main-layout/MainLayout";
import { titles } from "constants/titles";
import { useLocation } from "react-router-dom";
import moment from "moment";

const OrderDetails = () => {
  const location = useLocation();
  const orderData = location?.state?.orderDetail;
  const orderDetail = orderData?.order_detail;
  const products = orderData?.products;
  const payment_details = orderData?.payment_details;

  return (
    <MainLayout
      text={titles?.order_detail}
      isBackHide={false}
      isNavbar={true}
      white={true}
    >
      <div className="od_main_container">
        <div className="od_content_container">
          {/* Order Summary Section */}
          <div className="od_section">
            <h2 className="od_section_title">
              {titles?.order} {orderDetail?.order_id}
            </h2>
            <div className="od_summary_card">
              <div className="od_summary_row">
                <p className="od_summary_label">{titles?.date}</p>
                <p className="od_summary_value">
                  {moment(orderDetail?.order_date)?.format("MM/DD/YYYY")}
                </p>
              </div>
              <div className="od_summary_row">
                <p className="od_summary_label">{titles?.subscription}</p>
                <p className="od_summary_value">{orderDetail?.subscription}</p>
              </div>
              <div className="od_summary_row">
                <p className="od_summary_label">{titles?.total}</p>
                <p className="od_summary_value">
                  {`$${orderDetail?.total_recurring_fees?.toFixed(2)}`}
                </p>
              </div>
            </div>
          </div>

          {/* Products Ordered Section */}
          <div className="od_section">
            <h2 className="od_section_title">{titles?.products_ordered}</h2>
            <div className="od_products_list">
              {products?.map((item, index) => {
                return (
                  <div key={`product-${index}`} className="od_product_card">
                    <p className="od_product_name">{item?.product_name}</p>
                    <div className="od_product_details">
                      <div className="od_product_row">
                        <p className="od_product_label">{titles?.quantity}</p>
                        <p className="od_product_value">{item?.product_quantity}</p>
                      </div>
                      <div className="od_product_row">
                        <p className="od_product_label">{titles?.total}</p>
                        <p className="od_product_value">
                          {`$${item?.total_price?.toFixed(2)}`}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Payment Method Section */}
          <div className="od_section">
            <h2 className="od_section_title">{titles?.payment_method}</h2>
            <div className="od_payment_card">
              <div className="od_payment_row">
                <p className="od_payment_label">{titles?.credit_card_type}</p>
                <p className="od_payment_value">{payment_details?.card_type || '-'}</p>
              </div>
              <div className="od_payment_row">
                <p className="od_payment_label">{titles?.credit_card_number}</p>
                <p className="od_payment_value">{payment_details?.card_number || '-'}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default OrderDetails;
